export default __webpack_public_path__ + "static/media/section2-img1.d601e7df.png";